import Vue from 'vue';

export const mycomponent = Vue.component('mycomponentone', {
  template: '<div>A custom component - 1!</div>',
});

export const mycomponent2 = Vue.component('mycomponentwo', {
  template: '<div>A custom component - 2!</div>',
});



// WEBPACK FOOTER //
// ./src/components/common/global_components.js